import React from 'react'
import { 
    Button, 
    Table, 
    Row, 
    Divider, 
    Popconfirm, 
    Modal, 
    Input, 
    DatePicker, 
    TimePicker, 
    Progress,
    message,
} from 'antd'
import { firestore, firStorage } from '../../../service/firebase'
import './ExclusiveOffer.scss'
import moment from 'moment'

const { TextArea } = Input


export default class ExclusiveOffer extends React.Component {
    
    columns = [
        { title: "Title", dataIndex: 'title', key: 'title' },
        { title: "Location", dataIndex: 'location', key: 'location' },
        { title: "Start At", dataIndex: 'start_at', key: 'start_at', render: start => this.dateDetail(start) },
        { title: "End At", dataIndex: 'end_at', key: 'end_at', render: end => this.dateDetail(end) },
        { title: "Logo", dataIndex: 'logo', key: 'logo', render: logo => {
            return <img src={logo} style={{maxWidth: 50, maxHeight: 50}} alt="IMG-LOGO" />
        } },
        { title: 'Actions', dataIndex: '', key: 'action', render: (item) => {
            return (
                <span>
                    <a onClick={() => this.handleEdit(item)}>Edit</a>
                    <Divider type="vertical" />
                    <Popconfirm title="Are you sure delete?" onConfirm={() => this.handleDelete(item)} okText="Yes" cancelText="No">
                        <a>Delete</a>
                    </Popconfirm>
                </span>
            )
        }}
    ]

    dataList = []
    
    state = {
        showModal: false,
        uploadState: 0,
        downloadURL: '',
    }

    /*--------------------------------------------------------------*/
    /* Constructor */
    /*--------------------------------------------------------------*/

    constructor(props) {
        super(props)
        this.loadEvents()
    }


    /*--------------------------------------------------------------*/
    /* Load data */
    /*--------------------------------------------------------------*/

    loadEvents() {

        firestore.collection('ExclusiveOffer')
        .onSnapshot(snapshot => {
    
            snapshot.docChanges().forEach(change => {
    
                let data = change.doc.data()
    
                if(change.type === 'added') {

                    this.dataList.push(data)

                } else if(change.type === 'modified') {

                    this.dataList = this.dataList.map(item => {
                        if(item.id === data.id) {
                            return data
                        } else {
                            return item
                        }
                    })

                } else {

                    for(let i = 0; i < this.dataList.length; i++) {
                        let item = this.dataList[i]
                        if(item.id === data.id) {
                            this.dataList.splice(i, 1)
                            break
                        }
                    }

                }
            })
    
            this.forceUpdate()
        })
    
    }


    /*--------------------------------------------------------------*/
    /* Format functions */
    /*--------------------------------------------------------------*/

    dateFormat(date) {
        let year = this.numberFormat(date.getFullYear())
        let month = this.numberFormat(date.getMonth())
        let day = this.numberFormat(date.getDate())
        let hr = this.numberFormat(date.getHours())
        let min = this.numberFormat(date.getMinutes())

        return year + '/' + month + '/' + day + ' ' + hr + ':' + min
    }

    numberFormat(num) {
        return num > 9 ? num + '' : '0' + num
    }

    dateDetail(date) {
        if(date) {
            let dateStr = this.dateFormat(date.toDate())
            return (<div>{dateStr}</div>)
        } else {
            return (<div> - </div>)
        }
    }


    /*--------------------------------------------------------------*/
    /* Handle Functions */
    /*--------------------------------------------------------------*/

    handleAdd() {
        this.eventEdit = false
        this.setState({
            title: '',
            sub_title: '',
            offer_total: 0,
            description: '',
            location: '',
            id: '',
            email: '',
            phone: '',
            location: '',

            logo: null,
            startDate: null,
            startTime: null,
            endDate: null,
            endTime: null,

            start_at: null,
            end_at: null,

            showModal: true,
            uploadState: 0,
        })
    }

    handleEdit(item) {
        this.eventEdit = true
        let state = this.state

        let start = item.start_at ? item.start_at.toDate().toISOString() : null
        let end = item.end_at ? item.end_at.toDate().toISOString() : null

        let added = {}

        if(start) {
            added = Object.assign(added, {
                startDate: moment(start, 'YYYY-MM-DD'),
                startTime: moment(start, 'HH:mm::ss'),
            })
        }

        if(end) {
            added = Object.assign(added, {
                endDate: moment(end, 'YYYY-MM-DD'),
                endTime: moment(end, 'HH:mm::ss'),
            })
        }

        let newState = Object.assign(state, item, added, {
            showModal: true,
            uploadState: 2,
        })

        console.log("Edit State", newState)
        this.setState(newState)
    }

    handleChange(key, value) {
        let state = this.state
        state[key] = value
        this.setState(state)
    }
    
    handleDelete(item) {
        firestore.collection('ExclusiveOffer').doc(item.id).delete();
    }

    handleOK() {
        let state = this.state

        let id = state.id
        let ref

        if(!this.eventEdit) {
            ref = firestore.collection('ExclusiveOffer').doc()
            id = ref.id
        } else {
            ref = firestore.collection('ExclusiveOffer').doc(id)
        }

        let start = this.dateFor(state.startDate, state.startTime)
        let end = this.dateFor(state.endDate, state.endTime)

        let object = {
            id,
            type: 'offer',
            title: state.title,
            sub_title: state.sub_title,
            offer_total: state.offer_total,
            description: state.description,
            location: state.location,
            email: state.email,
            phone: state.phone,
            logo: state.logo,
            start_at: start,
            end_at: end,
        }

        if(!this.eventEdit) {
            ref.set(object)
        } else {
            ref.update(object)
        }

        this.setState({showModal: false})
    }

    dateFor(date, time) {

        if(!date || !time) return null

        let dateStr = date.format('YYYY-MM-DD')
        let timeStr = time.format('HH:mm:ss')

        return new Date(dateStr + 'T' + timeStr + '.000')
    }

    handleClose() {
        this.setState({showModal: false})
    }


    /*-----------------Upload Image-------------------*/

    handleUpload(input) {
        input.click();
    }

    onChangeFile(evt, type) {
        let orgName = evt.target.files[0].name;
        let key = Date.now();
        let fileName = this.page + "_" + key + "." + orgName.substring(orgName.length - 3);
        let path = '/' + this.page + '/' + fileName;
        this.uploadFile(evt.target.files[0], path, type);
    }
    
    uploadFile(file, path, type) {
        if(this.state.uploadState === 1) {
            return;
        }

        this.setState({uploadState: 1});

        var uploadTask = firStorage.ref().child(path).put(file);
        uploadTask.on('state_changed', (snapshot) => {
            var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            this.setState({uploadProgress: progress});
            console.log('Upload is ' + progress + '% done');
        }, (error) => {
            this.setState({uploadState: 0});
            message.error("Failed on uploading image! Try again please!");
        }, () => {
            uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
                console.log('File available at', downloadURL);
                this.setState({
                    uploadState: 2,
                    logo: downloadURL
                });
            });
        });
    }


    /*--------------------------------------------------------------*/
    /* Render Functions */
    /*--------------------------------------------------------------*/

    renderCellDetail(row) {
        console.log(row)

        return(
            <Row className="cell">
                <div className="img">
                    <img src={row.logo} alt="IMG-LOGO" />
                </div>

                <div className="content">
                    <div className="content-row"><div className="caption"><b>Title :</b></div>{row.title}</div>
                    <div className="content-row"><div className="caption"><b>Sub Title :</b></div>{row.sub_title}</div>
                    <div className="content-row"><div className="caption"><b>Email :</b></div>{row.email}</div>
                    <div className="content-row"><div className="caption"><b>Phone :</b></div>{row.phone}</div>
                    <div className="content-row"><div className="caption"><b>Total Offers :</b></div>{row.offer_total}</div>
                    <div className="content-row"><div className="caption"><b>Start Time :</b></div> {this.dateDetail(row.start_at)}</div>
                    <div className="content-row"><div className="caption"><b>End Time :</b></div> {this.dateDetail(row.end_at)}</div>
                    <div style={{margin: '20px 5px 5px 5px', display: 'flex'}}><div className="caption"><b>Description :</b></div></div>
                    <div style={{margin: 5, marginLeft: 100}}>{row.description}</div>
                </div>
            </Row>
        )
    }

    
    render() {

        return (
            <div className="calendar-event">

                <Row style={{textAlign: 'right', padding: 10}}>
                    <Button type="primary" icon="plus" onClick={() => this.handleAdd()}>Exclusive Offer</Button>
                </Row>

                <Table 
                    style={{margin: 10, background: 'white'}}
                    columns={this.columns}
                    expandedRowRender={record => this.renderCellDetail(record)} 
                    rowKey={record => record.id}
                    dataSource={this.dataList} />

                
                <Modal
                    title={this.eventEdit ? 'Edit event' : "Add event"}
                    visible={this.state.showModal}
                    onOk={() => this.handleOK()}
                    onCancel={() => this.handleClose()}>

                    <Row className="input-row">
                        <div className="input-label">Title</div>
                        <Input value={this.state.title} onChange={evt => this.handleChange('title', evt.target.value)} />
                    </Row>

                    <Row className="input-row">
                        <div className="input-label">Sub Title</div>
                        <Input value={this.state.sub_title} onChange={evt => this.handleChange('sub_title', evt.target.value)} />
                    </Row>

                    <Row className="input-row">
                        <div className="input-label">Email</div>
                        <Input value={this.state.email} onChange={evt => this.handleChange('email', evt.target.value)} />
                    </Row>

                    <Row className="input-row">
                        <div className="input-label">Phone</div>
                        <Input value={this.state.phone} onChange={evt => this.handleChange('phone', evt.target.value)} />
                    </Row>

                    <Row className="input-row">
                        <div className="input-label">Location</div>
                        <Input value={this.state.location} onChange={evt => this.handleChange('location', evt.target.value)} />
                    </Row>

                    <Row className="input-row">
                        <div className="input-label">Total Offer</div>
                        <Input value={this.state.offer_total} onChange={evt => this.handleChange('offer_total', evt.target.value)} />
                    </Row>

                    {
                        this.state.showModal &&
                        <Row className="input-row">
                            <div className="input-label">Start At</div>
                            <DatePicker defaultValue={this.state.startDate} onChange={date => this.handleChange('startDate', date)} />
                            <TimePicker defaultValue={this.state.startTime} style={{marginLeft: 10}} onChange={time => this.handleChange('startTime', time)} />
                        </Row>
                    }

                    {
                        this.state.showModal &&
                        <Row className="input-row">
                            <div className="input-label">End At</div>
                            <DatePicker defaultValue={this.state.endDate} onChange={date => this.handleChange('endDate', date)} />
                            <TimePicker defaultValue={this.state.endTime} style={{marginLeft: 10}} onChange={time => this.handleChange('endTime', time)} />
                        </Row>
                    }

                    <Row className="input-row">
                        <div className="input-label">Description</div>
                        <TextArea autosize={{minRows: 3, maxRows: 9}} value={this.state.description} onChange={evt => this.handleChange('description', evt.target.value)} />
                    </Row>

                    <Row className="input-row">
                        <div className="input-label">Logo Image</div>
                        <div style={{cursor: 'pointer'}} onClick={() => this.handleUpload(this.logoInput)}>
                        {
                            this.state.uploadState === 0 ?
                                <div className="logo-placeholder">Logo</div> :
                            this.state.uploadState === 1 ?
                                <div style={{margin: 20}}>
                                    <Progress type="circle" percent={this.state.uploadProgress ? Number(this.state.uploadProgress.toFixed(2)) : 0} />
                                </div> :
                                <div className="logo-img">
                                    <img src={this.state.logo} alt="IMG-LOGO" />
                                </div>
                        }
                        </div>
                    
                        <input type="file" className="file-input"
                            ref={input => this.logoInput = input}
                            onChange={evt => this.onChangeFile(evt)}
                            accept="image/x-png,image/gif,image/jpeg" />

                    </Row>

                </Modal>

            </div>
        )
    }
}
